// extracted by mini-css-extract-plugin
module.exports = {"logo":"imprint-module--logo--2sSOb","wrapper":"imprint-module--wrapper--2Y2I5"};